import { render, staticRenderFns } from "./WeightTable.vue?vue&type=template&id=350de4c0&"
import script from "./WeightTable.vue?vue&type=script&lang=js&"
export * from "./WeightTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/nc21docker/apps/health/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('350de4c0')) {
      api.createRecord('350de4c0', component.options)
    } else {
      api.reload('350de4c0', component.options)
    }
    module.hot.accept("./WeightTable.vue?vue&type=template&id=350de4c0&", function () {
      api.rerender('350de4c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/weight/WeightTable.vue"
export default component.exports